import { jsx as _jsx } from "react/jsx-runtime";
// Task 10: bridge context -> panel props (giữ panel + tests Task 09 nguyên vẹn).
import { useTradingContext } from "../context/TradingContext";
import { TradingBottomPanel } from "./TradingBottomPanel";
export function ConnectedTradingPanel({ onClose }) {
    const { panelProps } = useTradingContext();
    return _jsx(TradingBottomPanel, { ...panelProps, onClose: onClose });
}
